// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilização do rodapé global */
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--screen-background);
  border-radius: 20px 0px 0px 0px;
  box-shadow: -2px -1px 6px 0px rgba(0, 0, 0, 0.25);
}

.footer-border {
  border-top: 1px solid var(--primary-font);
  border-left: 1px solid var(--primary-font);
  box-shadow: none;
}

/* Estilização do rodapé */
.footer-buttons {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  max-width: 1830px;
}

.price-handler {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 19px;
  border-radius: 100px;
  border: 1.25px solid var(--terciary-font);
  color: var(--terciary-font);
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.loading-price {
  padding-left: 1.5rem;
  margin-top: -3.5px;
}

.work-label {
  color: var(--text);
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.totalPrice {
  color: var(--accept-selection);
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.symbols {
  color: var(--accept-selection);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.totalPriceNotCalculated {
  color: #d64545;
  font-size: 12px;
  font-weight: 600;
}

button:only-child {
  margin-left: auto;
}

.footer-buttons-gap {
  justify-content: center;
  gap: 24.79px;
}

.footer-buttons-comprar {
  flex-direction: column;
  height: auto;
  padding: 12px 16px 16px;
  gap: 6px;
}

.footer-comprar {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 15px;
}

.footer-comprar-text {
  color: var(--text);
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  margin: 0;
}

/* Botão avançar */
::ng-deep #button-material-active .mat-button-wrapper {
  display: flex;
  align-items: center;
  gap: .5rem;
  font-size: .875rem;
}

.seta-avancar {
  width: 1rem;
}

/* botões icones globais */
:host ::ng-deep footer .mat-icon-button {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-background);
}

/* botões globais */
:host ::ng-deep footer .mat-raised-button.mat-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 40px;
  border-radius: 100px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  background-color: var(--primary-background);
  color: var(--primary-font);
}

:host ::ng-deep footer .pular {
  display: flex;
  width: 130px;
  height: 32px;
  color: var(--terciary-font);
  line-height: normal;
  align-items: center;
  justify-content: center;
  border-radius: 80px;
  flex-shrink: 0;
  border: 1.5px solid var(--terciary-font);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

@media screen and (min-width: 768px) {
  .footer-buttons {
    height: 60px;
    max-width: 70%;
    padding: 0px;
    gap: 30px;
  }

  .button-filter-footer{
    display: none !important;
  }

  .footer-buttons-gap {
    justify-content: center;
    gap: 24.79px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/proforma-footer/proforma-footer.component.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;AACF","sourcesContent":["/* Estilização do rodapé global */\nfooter {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: var(--screen-background);\n  border-radius: 20px 0px 0px 0px;\n  box-shadow: -2px -1px 6px 0px rgba(0, 0, 0, 0.25);\n}\n\n.footer-border {\n  border-top: 1px solid var(--primary-font);\n  border-left: 1px solid var(--primary-font);\n  box-shadow: none;\n}\n\n/* Estilização do rodapé */\n.footer-buttons {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  max-width: 1830px;\n}\n\n.price-handler {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 65px;\n  height: 19px;\n  border-radius: 100px;\n  border: 1.25px solid var(--terciary-font);\n  color: var(--terciary-font);\n  text-align: center;\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.loading-price {\n  padding-left: 1.5rem;\n  margin-top: -3.5px;\n}\n\n.work-label {\n  color: var(--text);\n  font-family: Roboto;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.totalPrice {\n  color: var(--accept-selection);\n  font-family: Roboto;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.symbols {\n  color: var(--accept-selection);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.totalPriceNotCalculated {\n  color: #d64545;\n  font-size: 12px;\n  font-weight: 600;\n}\n\nbutton:only-child {\n  margin-left: auto;\n}\n\n.footer-buttons-gap {\n  justify-content: center;\n  gap: 24.79px;\n}\n\n.footer-buttons-comprar {\n  flex-direction: column;\n  height: auto;\n  padding: 12px 16px 16px;\n  gap: 6px;\n}\n\n.footer-comprar {\n  display: flex;\n  /* flex-direction: column; */\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 15px;\n}\n\n.footer-comprar-text {\n  color: var(--text);\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: center;\n  margin: 0;\n}\n\n/* Botão avançar */\n::ng-deep #button-material-active .mat-button-wrapper {\n  display: flex;\n  align-items: center;\n  gap: .5rem;\n  font-size: .875rem;\n}\n\n.seta-avancar {\n  width: 1rem;\n}\n\n/* botões icones globais */\n:host ::ng-deep footer .mat-icon-button {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--primary-background);\n}\n\n/* botões globais */\n:host ::ng-deep footer .mat-raised-button.mat-primary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 160px;\n  height: 40px;\n  border-radius: 100px;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: uppercase;\n  background-color: var(--primary-background);\n  color: var(--primary-font);\n}\n\n:host ::ng-deep footer .pular {\n  display: flex;\n  width: 130px;\n  height: 32px;\n  color: var(--terciary-font);\n  line-height: normal;\n  align-items: center;\n  justify-content: center;\n  border-radius: 80px;\n  flex-shrink: 0;\n  border: 1.5px solid var(--terciary-font);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n@media screen and (min-width: 768px) {\n  .footer-buttons {\n    height: 60px;\n    max-width: 70%;\n    padding: 0px;\n    gap: 30px;\n  }\n\n  .button-filter-footer{\n    display: none !important;\n  }\n\n  .footer-buttons-gap {\n    justify-content: center;\n    gap: 24.79px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
